'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQItem {
  id: string;
  question: string;
  answer: string;
}

export default function OrderingSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const faqs: FAQItem[] = [
    {
      id: 'order_1',
      question: 'How do I order Bloom concentrates?',
      answer: 'You can order Bloom concentrates through our network of authorized agro-vet distributors across Uganda, or contact us directly at 0777 014 115 or 0704 846 600. You can also email us at info@bloomanimalfeeds.com or fill out the inquiry form on our Contact page.'
    },
    {
      id: 'order_2',
      question: 'What are the minimum order quantities?',
      answer: 'Minimum order quantities vary depending on whether you are ordering as an individual farmer or a distributor. For individual farmers, we typically require a minimum order that makes delivery economical. For bulk and distributor orders, different minimums apply. Contact our sales team for specific MOQ details.'
    },
    {
      id: 'order_3',
      question: 'What payment methods do you accept?',
      answer: 'We accept multiple payment methods including bank transfers, mobile money (MTN and Airtel), and cash on delivery for qualified orders. For large orders, we can arrange flexible payment terms. Contact our sales team to discuss payment options that work best for your farm.'
    },
    {
      id: 'order_4',
      question: 'What are the delivery options?',
      answer: 'We offer delivery across Uganda through our logistics network. Delivery times vary based on location, with major towns typically receiving orders within 2-3 business days. For remote areas, delivery may take 5-7 days. Bulk orders can be arranged for direct delivery to your farm. Delivery fees apply based on location and order size.'
    }
  ];

  const toggleFAQ = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-section-sm px-6 bg-secondary/5">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <h2 className="text-heading-3 text-foreground mb-4">Ordering & Purchasing</h2>
          <p className="text-muted-foreground">
            Everything you need to know about placing orders, payment methods, and delivery.
          </p>
        </div>

        <div className="space-y-4">
          {faqs?.map((faq) => (
            <div
              key={faq?.id}
              className="bg-white rounded-lg border border-border overflow-hidden transition-all hover:shadow-md"
            >
              <button
                onClick={() => toggleFAQ(faq?.id)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-secondary/5 transition-colors"
              >
                <span className="font-semibold text-foreground pr-4">{faq?.question}</span>
                <Icon
                  name={openId === faq?.id ? 'ChevronUpIcon' : 'ChevronDownIcon'}
                  size={20}
                  className="text-primary flex-shrink-0"
                />
              </button>
              {openId === faq?.id && (
                <div className="px-6 pb-5 text-muted-foreground leading-relaxed">
                  {faq?.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}